export default {
  form: {
    gtin: {
      label: 'GTIN',
    },
    pfand: {
      label: 'Statiegeld',
    },
    product_type: {
      label: 'Producttype',
      options: {
        packaged: 'Verpakt',
        prepared: 'Bereid',
      },
    },
    packaging_material: {
      label: 'Verpakkingsmateriaal',
    },
    brand_or_manufacturer: {
      label: 'Merk of fabrikant',
    },
    net_quantity: {
      label: 'Netto hoeveelheid',
    },
    base_price: {
      label: 'Prijs per eenheid instellen (bijv. per liter voor een drank)',
      placeholder: 'Prijs per eenheid',
    },
    alcohol_by_volume_percent: {
      label: 'Alcoholpercentage',
    },
    caffeine_mg_per_100ml: {
      label: 'Cafeïne (mg per 100ml product)',
    },
    ingredients_text: {
      label: 'Ingrediënten',
    },
    allergens_list: {
      label: 'Allergenen',
    },
    additives_list: {
      label: 'Additieven',
    },
    has_nutrition_table: {
      label: 'Vul voedingstabel in (per 100{{unit}} product)',
    },
    energy_kj: {
      label: 'Energie (kJ)',
    },
    energy_kcal: {
      label: 'Energie (kcal)',
    },
    fat_g: {
      label: 'Vetten',
    },
    saturates_g: {
      label: 'Verzadigde vetten',
    },
    carbohydrate_g: {
      label: 'Koolhydraten',
    },
    sugars_g: {
      label: 'Suikers',
    },
    protein_g: {
      label: 'Eiwitten',
    },
    salt_g: {
      label: 'Zout',
    },
    identifiers: {
      label: 'Identificatoren',
    },
  },
};
